import Layout from "../../layout";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
import Loader from "../../components/Reusable/Loader";
import { useEffect } from "react";
import { useRouter } from "next/router";

const PAGE_CONFIG_URL = "/api/privacy-policy/config/";
const PrivacyPolicy = ({ initialData, cookie="en" }) => {
  const router = useRouter();
  const { data: privacyPolicyData, error: privacyPolicyError } = useSWR(
    `/api/privacy-policy?language=${cookie}`,
    fetcher,
    { fallbackData: initialData }
  );

  useEffect(() => {
    router.replace(router.asPath);
  }, []);

  return (
    <div>
      {!privacyPolicyData ? (
        <Loader />
      ) : privacyPolicyError ? (
        <div className="terms_policy">
          <h1>Something went wrong</h1>
        </div>
      ) : (
        <>
          <div className="terms_policy">
            <h1>{privacyPolicyData.privacy_policy.name}</h1>
            <hr />
            <div
              dangerouslySetInnerHTML={{
                __html: privacyPolicyData?.privacy_policy?.value,
              }}
            />
          </div>
        </>
      )}
    </div>
  );
};

export async function getServerSideProps(context) {
  const cookie = context.req.cookies?.language || "en"; // default fallback
  const initialData = await fetcher(`/api/privacy-policy?language=${cookie}`);

  return {
    props: {
      initialData,
      cookie,
    },
  };
}

PrivacyPolicy.getLayout = (page) => (
  <Layout configUrl={PAGE_CONFIG_URL}>{page}</Layout>
);

export default PrivacyPolicy;
